import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import Logo from './Logo';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0">
              <Logo variant="dark" />
            </Link>
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-900 hover:text-primary">Home</Link>
            
            {/* About Us Dropdown */}
            <div className="relative group">
              <button 
                className="text-gray-900 hover:text-primary flex items-center gap-1"
                onMouseEnter={() => setShowDropdown(true)}
                onClick={() => setShowDropdown(!showDropdown)}
              >
                About Us
                <ChevronDown size={16} />
              </button>
              
              {showDropdown && (
                <div 
                  className="absolute left-0 mt-2 w-64 bg-white border border-gray-200 rounded-lg shadow-lg py-2 z-50"
                  onMouseLeave={() => setShowDropdown(false)}
                >
                  <Link 
                    to="/about" 
                    className="block px-4 py-2 text-gray-900 hover:bg-gray-50"
                    onClick={() => setShowDropdown(false)}
                  >
                    Company Overview
                  </Link>
                  <Link 
                    to="/knowledge-base" 
                    className="block px-4 py-2 text-gray-900 hover:bg-gray-50"
                    onClick={() => setShowDropdown(false)}
                  >
                    Knowledge Base
                  </Link>
                  <Link 
                    to="/gallery" 
                    className="block px-4 py-2 text-gray-900 hover:bg-gray-50"
                    onClick={() => setShowDropdown(false)}
                  >
                    Repair Gallery
                  </Link>
                </div>
              )}
            </div>
            
            <Link to="/submit-ticket" className="text-gray-900 hover:text-primary">Submit a Ticket</Link>
            <Link to="/contact" className="text-gray-900 hover:text-primary">Contact</Link>
            <Link 
              to="/submit-ticket" 
              className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/90 transition-colors"
            >
              Get Support
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-900 hover:text-primary focus:outline-none"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <Link 
              to="/" 
              className="block px-3 py-2 text-gray-900 hover:text-primary"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className="block px-3 py-2 text-gray-900 hover:text-primary"
              onClick={() => setIsOpen(false)}
            >
              About Us
            </Link>
            <Link 
              to="/knowledge-base" 
              className="block px-3 py-2 text-gray-900 hover:text-primary pl-6"
              onClick={() => setIsOpen(false)}
            >
              Knowledge Base
            </Link>
            <Link 
              to="/gallery" 
              className="block px-3 py-2 text-gray-900 hover:text-primary pl-6"
              onClick={() => setIsOpen(false)}
            >
              Repair Gallery
            </Link>
            <Link 
              to="/submit-ticket" 
              className="block px-3 py-2 text-gray-900 hover:text-primary"
              onClick={() => setIsOpen(false)}
            >
              Submit a Ticket
            </Link>
            <Link 
              to="/contact" 
              className="block px-3 py-2 text-gray-900 hover:text-primary"
              onClick={() => setIsOpen(false)}
            >
              Contact
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}